import { bmResidence } from '../config/baseConfig';

export interface AuthenticationResult {
  accessToken: string;
  organizationId: string;
  personaId: string;
  refreshToken: string;
  userId: string;
}

export interface ManagementCompanyResponse {
  statusCode: number;
  data?: {
    managementCompanyName?: string;
    managementCompanyAddress?: string;
    managementCompanyPhoneNumber?: string;
    notificationEmail?: string;
  };
}

export interface OrganizationData {
  id: string;
  name: string;
}
export interface OrganizationsByIds {
  statusCode: number;
  data?: [OrganizationData];
}

export function getManagementCompany(allSpaceId: string, accessToken: string): Promise<ManagementCompanyResponse> {
  const managementComapnyEndpoint = `${bmResidence}spaces/${allSpaceId}/management_company`;
  const method = 'GET';
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'x-api-key': accessToken
  };

  return fetch(managementComapnyEndpoint, {
    method,
    headers,
    mode: 'cors'
  })
    .then(res => {
      if (res.status !== 200) {
        return { statusCode: res.status };
      }
      return res
        .json()
        .then(json => {
          console.log('json', json);
          return {
            statusCode: 200,
            data: {
              managementCompanyName: json.managementCompanyName,
              managementCompanyAddress: json.managementCompanyAddress,
              managementCompanyPhoneNumber: json.managementCompanyPhoneNumber,
              notificationEmail: json.notificationEmail
            }
          };
        })
        .catch(e => {
          console.log(e);
          return {
            statusCode: e.status
          };
        });
    })
    .catch(e => {
      console.log(e);
      return {
        statusCode: e.status
      };
    });
}
/**
 * 組織UUIDから管理会社名を取得するためのメソッド
 * 物件情報のAlgoliaデータに管理画面名をもたせるのは、会社名変更時などの更新コストを考え却下
 */
export function getOrganizationsByIds(ids: Array<string>, apiKey: string): Promise<OrganizationsByIds> {
  const endPoint = `${bmResidence}organizations/getOrganizationsByIds`;
  const method = 'POST';
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'x-api-key': apiKey
  };
  const body = JSON.stringify({ ids });

  return fetch(endPoint, {
    method,
    headers,
    body,
    mode: 'cors'
  })
    .then(res => {
      if (res.status !== 200) {
        return { statusCode: res.status };
      }
      return res
        .json()
        .then(json => {
          return {
            statusCode: 200,
            data: json.data
          };
        })
        .catch(e => {
          console.log(e);
          return {
            statusCode: e.status
          };
        });
    })
    .catch(e => {
      console.log(e);
      return {
        statusCode: e.status
      };
    });
}
